import GoogleErrorSvg from '@/assets/googleTheme/error.svg'
import GoogleSuccessSvg from '@/assets/googleTheme/success.svg'
import GoogleResetPasswordSvg from '@/assets/googleTheme/resetPassword.svg'

import OktaErrorSvg from '@/assets/oktaTheme/error.svg'
import OktaResetPasswordSvg from '@/assets/oktaTheme/resetPassword.svg'

export default {
  googleTheme: {
    error: GoogleErrorSvg,
    success: GoogleSuccessSvg,
    resetPassword: GoogleResetPasswordSvg,
  },
  oktaTheme: {
    error: OktaErrorSvg,
    success: null,
    resetPassword: OktaResetPasswordSvg,
  },
}
